import React, { useEffect, useState} from 'react'
import Toolbar, { Item } from 'devextreme-react/toolbar'
import Button from 'devextreme-react/button'
import UserPanel from '../user-panel/user-panel'
import './header.scss'
import { Template } from 'devextreme-react/core/template'
import {Link, useLocation} from "react-router-dom"
import { getHomeRoute } from '../../utils/navigation.utils'
import { dogHasParameterMenu, menuMatchesParameter } from '../../utils/admin.utils'
import ThemeSelect from "../theme-select/theme-select"
import {lettersWidget,paysWidget,readsWidget,agregatorWidget} from '../../data/homeWidgetsData'
import themes from "devextreme/ui/themes"
import { useAuth } from '../../contexts/auth'
import { useReqPopup } from '../../contexts/req-popup'
import PopupRefreshOldPeriod from "../popup-refresh-old-period/popup-refresh-old-period";
import notify from "devextreme/ui/notify";
//import {setBankPayStatus} from "../../api/dogovor";
import { useHistory } from 'react-router';
import {useScreenSize} from "../../utils/media-query";
//import {Popover} from "devextreme-react/popover";



themes.initialized(() =>{
      if (window.localStorage.getItem("dx-theme")==null) {window.localStorage.setItem("dx-theme","generic.light")}
      themes.current(window.localStorage.getItem("dx-theme"))
    }
);
const Header = ({ menuToggleEnabled, toggleMenu, handleHeaderClick }) => {
  const [visibleRefreshPopup, setVisibleRefreshPopup] = useState(false)
  const [widgets, setWidgets] = useState([])
  const {lettersCount, countDogovors, dogovors, nextAgrEventsCount, countNotReads, countVistSf, selectedDog, topNavigation, newMenu } = useAuth()
  const { openReqPopup } = useReqPopup()
  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)
  const rezult = queryParameters.get("rezult")
  const orderId = queryParameters.get("mdOrder")
  const bank = queryParameters.get("bank")
  const history = useHistory();
  let { isXSmall } = useScreenSize();
  useEffect(() => {
    (async function() {
      if (rezult) {
        console.log('rezult--' + rezult)
        // статусы наоборот у Алексея.
        let status = rezult==='true' ? 0 : 1
        console.log('status--' + status)
        if (rezult === 'true') {
          notify('Оплата проведена', 'success', 5000)
        } else if (rezult === 'false') {
          notify('Оплата не прошла', 'error', 5000)
        }
        /*const res = await setBankPayStatus(status, orderId, bank)
        if (res.isOk) {
          notify(res.message, 'success', 5000)
        } else {
          notify(res.message, 'error', 5000)
        }*/
        history.push('/debt')
      }
    })()
  }, [rezult, orderId, bank, history])

  useEffect(() => {
    let w
    if (newMenu && topNavigation.lettersWidget){
      topNavigation.lettersWidget.count = +lettersCount > 99 ? '99+' : lettersCount;
      topNavigation.readsWidget.count = +countNotReads > 99 ? '99+' : countNotReads;
      topNavigation.paysWidget.count = +countVistSf > 99 ? '99+' : countVistSf;
      w = Object.entries(topNavigation).map(([key, obj]) => ({ ...obj, _key: key }));
    } else {
      lettersWidget.count = +lettersCount > 99 ? '99+' : lettersCount;
      readsWidget.count = +countNotReads > 99 ? '99+' : countNotReads;
      paysWidget.count = +countVistSf > 99 ? '99+' : countVistSf;
      w = [
        { ...lettersWidget, _key: 'lettersWidget' },
        { ...paysWidget,    _key: 'paysWidget' },
        { ...readsWidget,   _key: 'readsWidget' },
      ]
    }

    // если не рязань добавляем в меню агрегатор спроса
    //TODO: Перенести все настройки пунктов меню HEADER и Side-nav-bar в БД
    if (process.env.REACT_APP_VISIBLE_AGREGATOR_SPROSA_IN_MENU !== 'false' && !newMenu) {
      agregatorWidget.count = +nextAgrEventsCount > 99 ? '99+' : nextAgrEventsCount;
      w.push({ ...agregatorWidget, _key: 'agregatorWidget' })
    }

    if (!dogovors?.length) {
      w = w.filter(item => item.all_users_visible === true || item.all_users_visible === 'true')
      // без договора parameter_menu не применяем
    } else {
      //фильтруем parameter_menu (договор может иметь несколько ключей, напр. "2,4")
      w = w.filter(item => menuMatchesParameter(item.parameter_menu, selectedDog))
    }
    setWidgets(w)
  }, [selectedDog, countDogovors, countNotReads, countVistSf, dogovors.length, lettersCount, newMenu, nextAgrEventsCount, topNavigation])

  const homeRoute = getHomeRoute(dogovors, selectedDog);
  const isGP  = dogHasParameterMenu(selectedDog, '2');
  const isNESK = dogHasParameterMenu(selectedDog, '0');

  const btnAddClick = () => {
    openReqPopup(true,1)
  }

  const setVisibleRefreshOldPeriodPopupFun = (e) =>{
    setVisibleRefreshPopup(e)
  }

  return (
  <>
    <header className={'header-component main-background-fon-second-color'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item location={'before'} cssClass={'header-title'}>
          <Link className="navbar-brand gradientsvg" to={homeRoute}>
            <img alt={`Логотип ` + process.env['REACT_APP_TITLE']} style={{ height: '3rem' }} src={process.env['REACT_APP_LOGO']}/>
          </Link>
        </Item>
        <Item location={'before'} cssClass={'header-title podpis-logo'} locateInMenu={'auto'}>
          <Link className="navbar-brand homemain" to={homeRoute}>
            <img alt={`Логотип ` + process.env['REACT_APP_TITLE']}
                 style={process.env['REACT_APP_HEIGHT_LOGO_PODPIS'] ? { height: process.env['REACT_APP_HEIGHT_LOGO_PODPIS'], width:'14rem'}:{ height: '2rem', width:'9rem' }}
                 src={process.env['REACT_APP_LOGO_PODPIS']}/>
          </Link>
        </Item>

            {widgets?.map((obj,i) => {
              const pinned = (isGP   && (obj._key === 'readsWidget' || obj._key === 'paysWidget'))
                          || (isNESK && obj._key === 'finWidget')
              return (<Item cssClass={'main-color-interact'} location={'before'} locateInMenu={pinned ? 'never' : 'auto'} key={i.toString()}>
                <Link className="dx-toolbar-menu-action" to={ (obj.url === "/docs" && obj.count > 0) ? '/debt#' : (countDogovors === 0 && dogovors.length === 0 && obj.url === "/agregator-events") ? '/agregator-reclame#' :obj.url+'#'}>
                  <div className="informer">
                    <h4 className="count">
                      {newMenu ? <div dangerouslySetInnerHTML={{__html: obj.svg}}/>:obj.svg}
                      {obj.count !== 0 ? <div><span className={obj.badgeClassName}>{obj.count}</span></div> : ''}</h4>
                    <span className="name">{obj.title}</span>
                  </div>
                </Link>
              </Item>)
            })}

            <Item  location={'before'} visible={countDogovors === 0 && dogovors.length === 0}>
              <Button className='ml-3 dx-toolbar-menu-action' icon='plus' text='Добавить договор в ЛК' onClick={btnAddClick}></Button>
            </Item>
            <Item
                cssClass=""
                location={'after'}
                locateInMenu="never"
            >
            </Item>
            <Item
                visible={!isXSmall}
                cssClass={'theme-select'}
                location={'after'}
                locateInMenu="always"
            >
              <div>
                <ThemeSelect />
              </div>
            </Item>
            <Item
                visible={dogovors.length > 0}
                location={'after'}
            >

            {process.env.REACT_APP_NAME_ENV !== 'tatenergosbyt' &&
                <div>
                  <a href="#/dogovor" id='link2' className='dog-href'>
                    {selectedDog ? `${!isXSmall ? "Договор " : ""}№` + selectedDog?.ndog : ''}
                  </a>
                </div>
            }
            {process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' &&

                <div className={'font10'}>
                  <strong>{selectedDog ? selectedDog?.name : ''}</strong><br/>
                  {selectedDog ? `ИНН: ${selectedDog?.inn}` : ''}
                  {selectedDog?.inn && <br/>}
                  {/*{selectedDog ? <span className='gray-color'>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span> : ''}*/}
                  <a href="#/dogovor" id='link2' className='dog-href'>
                    {selectedDog ? 'Договор №'+selectedDog?.ndog + (selectedDog.statusDog ? ` (${selectedDog.statusDog})`: '') : ''}
                  </a>
                </div>
            }
          {/*{process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' &&
          <Popover
              target="#link2"
              showEvent="mouseenter"
              hideEvent="click"
              position="top"
              width={300}
              showTitle={true}
              title='Информация'
          >
            <strong>{selectedDog ? selectedDog?.name : ''}</strong><br/>
            {selectedDog ? 'ИНН: '+selectedDog?.inn + '\r\n' : ''}

          </Popover>
          }*/}
            </Item>
            <Item className="dx-toolbar-menu-action"
                  location={'after'}
                  locateInMenu={'auto'}
                  menuItemTemplate={'userPanelTemplate'}
                  widget={'dxButton'}
            >
              <Button
                  className={'user-button authorization'}
                  //width={210}
                  height={'100%'}
                  stylingMode={'text'}
              >
                <UserPanel menuMode={'context'} setVisibleRefreshOldPeriodPopupFun={(e)=>setVisibleRefreshOldPeriodPopupFun(e)} />
              </Button>
            </Item>
            <Template name={'userPanelTemplate'}>
              <UserPanel menuMode={'list'} setVisibleRefreshOldPeriodPopupFun={(e)=>setVisibleRefreshOldPeriodPopupFun(e)} />
            </Template>
          </Toolbar>
          {visibleRefreshPopup &&
              <PopupRefreshOldPeriod
                  setVisibleRefreshOldPeriodPopupFun={(e)=>setVisibleRefreshOldPeriodPopupFun(e)}
              />
          }
        </header>
      </>
  )
}

export default Header
